import styled from 'styled-components';

interface ContainerPros {
  $height: number;
}

export const $AddAndRemoveContainer = styled.li<ContainerPros>`
  transition: 0.3s;
  list-style: none;

  &:last-child {
    padding-bottom: 0;
  }
`;

export const $AddAndRemoveSizer = styled.div``;
